export const parseDomain: (url: string) => string = (url: string) => url
  .replace(/https?/, '')
  .replace('://', '')
  .replace('www.', '')
  .replace(/(\/.*)/, '');